import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  loginDisclaimer: {
    id: 'report.summary.loginDisclaimer',
    description: 'Explains why login is required',
    defaultMessage:
      'Palvelun perustana on läpinäkyvyys ja luotettavuus. Tämän vuoksi edellytämme tunnistautumista arvioinneissa. Tunnistautumisen ansiosta voit myös nähdä ja muuttaa omia arviointejasi myöhemmin. Emme julkaise sähköpostia arvion yhteydessä, näytämme ainoastaan arvioijan etunimen ja mahdollisen profiilikuvan. Yritys voi ottaa palvelun kautta anonyymisti yhteyttä arvioijaan. Tunnistautuminen lisää luotettavuutta arviointeihin.',
  },
});
